import { render, staticRenderFns } from "./GovProposalConfirmation.vue?vue&type=template&id=abbdb3e8&"
import script from "./GovProposalConfirmation.vue?vue&type=script&lang=js&"
export * from "./GovProposalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./GovProposalConfirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports